import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { TdDialogService } from '@covalent/core';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { Piece } from '../../../inventory/piece';
import { InventoryService } from '../../../inventory/inventory.service';
import 'rxjs/add/operator/do';
import { PalletService } from 'app/shared/services/pallet.service';
import { Branch } from 'app/agatextscreens/accounting/branch';
import { Observable } from 'rxjs';
import { TdDialogContentDirective } from '@covalent/core/dialogs/dialog.component';
import { MdSnackBar } from '@angular/material';

@Component({
  selector: 'app-inv-change-pallet',
  templateUrl: './change-pallet.component.html',
  styleUrls: ['./change-pallet.component.scss'],
  providers: [PalletService]
})
export class InvChangeLocationComponent implements OnInit {
  title: string;

  multiMode: boolean = false;

  pieceNumber: any;
  pieceNumbers: string;

  sourcePallet: any;
  newPallet: any;

  allBranches$: Observable<Branch[]>;
  branchFilter: number;

  constructor(private _dialogService: TdDialogService,
    private _snackService: MdSnackBar,
    public _authService: AuthenticationService,
    private _inventoryService: InventoryService,
    private _palletSevice: PalletService,
    private location: Location) { }

  ngOnInit(): void {
    this.allBranches$ = Observable.of(this._authService.getUserBranches());
  }


  goBack(): void {
    this.location.back();
  }



  loadItems(sourcePallet: string): void {
    this._inventoryService.findByPallet(sourcePallet, this.branchFilter).subscribe(
      response => {

        let items: any[] = response;
        console.log(items);

        if (items && Array.isArray(items) && items.length > 0) {
          this.pieceNumbers = items.map(item => { return item.piece_number; }).join(' ');
        } else {
          this._dialogService.openAlert({
            title: 'No Pieces',
            message: 'No pieces found for ' + sourcePallet
          });
        }
      },
      error => {
        this._dialogService.openAlert({
          title: 'Error',
          message: 'Error loading pieces from ' + sourcePallet + ' ' + error
        });
      }
    );
  }


  changePallet(): void {
    this.changePiece(this.pieceNumber, this.newPallet);

    // clear the fields
    this.pieceNumber = '';
    this.pieceNumbers = '';
    this.newPallet = '';
  }


  changeAllPallet(): void {

    this.pieceNumbers.split(/\s+/).forEach(
      p => {
        if (p.trim().length > 0) {
          this.changePiece(p, this.newPallet);
        }
      });

    // clear the fields
    this.pieceNumber = '';
    this.pieceNumbers = '';
    this.newPallet = '';
  }

  private changePiece(piece: string, newPallet: string): void {

    // Get the piece ID for the piece numebr entered
    this._inventoryService.getPieceByPieceNumber(piece).subscribe(
      response => {
        console.log('response piece id:', response.id);

        // get the whole piece
        this._inventoryService.getPiece(response.id, true).subscribe(
          pieceResponse => {
            console.log('piece details;', pieceResponse[0]);

            // get the pallet entered
            this._palletSevice.getPalletByName(newPallet).subscribe(
              palletResponse => {
                if (palletResponse) {
                  console.log('pallet location:', palletResponse.location_branch_code);

                  // if pallet.branch and piece current pallet.branch are equal it's ok to update
                  if (palletResponse.location_branch_id == pieceResponse[0].branch_id) {

                    // branches are equal OK to change
                    pieceResponse[0].pallet_id = palletResponse.id;
                    this._inventoryService.updatePiece(pieceResponse[0]).subscribe(
                      updateResponse => {

                        console.log('Piece ' + piece + ' Moved Successfully');                        
                        this.showSnackBar('Piece ' + piece + ' Moved Successfully', 'DISMISS', 4000, 'success');

                        // this._dialogService.openAlert({
                        //   title: 'Success',
                        //   message: 'Piece ' + piece + ' Moved Successfully'
                        // });

                      }, error => {
                        this._dialogService.openAlert({
                          title: 'Unable to update piece' + piece,
                          message: 'Error updating piece: ' + error
                        });
                      }
                    );

                  } else {
                    // branches are different, can't move a piece to a different branch
                    this._dialogService.openAlert({
                      title: 'Different Branch',
                      message: 'You cannot move a piece to a different branch!'
                    });
                  }
                } else {
                  this._dialogService.openAlert({
                    title: 'Invalid Pallet',
                    message: 'Unable to find the pallet entered'
                  });
                }

              },
              error => {
                this._dialogService.openAlert({
                  title: 'Invalid Pallet',
                  message: 'Unable to find the pallet entered ' + error
                });
              });
          },
          error => {
            this._dialogService.openAlert({
              title: 'Invalid Piece',
              message: 'Unable to find the piece entered by ID: ' + error
            });
          }

        );
      },
      error => {
        this._dialogService.openAlert({
          title: 'Invalid Piece',
          message: 'Unable to find the piece entered: ' + error
        });
      }

    );

  }


  showSnackBar(message: string, action: string, duration: number, color: string): void {
    this._snackService.open(message, action, { duration: duration, extraClasses: ['snackbar-' + color] });
  }


  // changePallet(): void {

  //   // Get the piece ID for the piece numebr entered
  //   this._inventoryService.getPieceByPieceNumber(this.pieceNumber).subscribe(
  //     response => {
  //       console.log(response.id);

  //       // get the whole piece
  //       this._inventoryService.getPiece(response.id, true).subscribe(
  //         pieceResponse => {
  //           console.log(pieceResponse[0]);

  //           // get the pallet entered
  //           this._palletSevice.getPalletByName(this.newPallet).subscribe(
  //             palletResponse => {
  //               if (palletResponse) {
  //                 console.log(palletResponse.location_branch_code);

  //                 // if pallet.branch and piece current pallet.branch are equal it's ok to update
  //                 if (palletResponse.location_branch_id == pieceResponse[0].branch_id) {
  //                   // branches are equal OK to change
  //                   pieceResponse[0].pallet_id = palletResponse.id;
  //                   this._inventoryService.updatePiece(pieceResponse[0]).subscribe(
  //                     updateResponse => {
  //                       this._dialogService.openAlert({
  //                         title: 'Success',
  //                         message: 'Piece Moved successfully'
  //                       });

  //                       // clear the fields
  //                       this.pieceNumber = '';
  //                       this.newPallet = '';

  //                     }, error => {
  //                       this._dialogService.openAlert({
  //                         title: 'Unable to update piece',
  //                         message: 'Error updating piece: ' + error
  //                       });
  //                     }
  //                   );

  //                 } else {
  //                   // branches are different, can't move a piece to a different branch
  //                   this._dialogService.openAlert({
  //                     title: 'Different Branch',
  //                     message: 'You cannot move a piece to a different branch!'
  //                   });
  //                 }
  //               } else {
  //                 this._dialogService.openAlert({
  //                   title: 'Invalid Pallet',
  //                   message: 'Unable to find the pallet entered'
  //                 });
  //               }



  //             },
  //             error => {
  //               this._dialogService.openAlert({
  //                 title: 'Invalid Pallet',
  //                 message: 'Unable to find the pallet entered ' + error
  //               });
  //             });
  //         },
  //         error => {
  //           this._dialogService.openAlert({
  //             title: 'Invalid Piece',
  //             message: 'Unable to find the piece entered by ID: ' + error
  //           });
  //         }

  //       );
  //     },
  //     error => {
  //       this._dialogService.openAlert({
  //         title: 'Invalid Piece',
  //         message: 'Unable to find the piece entered: ' + error
  //       });
  //     }

  //   );
  // }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/pda/inventory/change-pallet/change-pallet.component.ts